module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sandy?” I couldn’t keep the edge out of my voice. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The last time we talked, we quarreled. Sander Arkelett, private detective for White, Sayres, among others, had been my lover for a while. I’d left him for Hal. He’d been a good sport, considering. But three months ago, attraction to another man showed me my feelings for Hal had reverted to familial. And Sandy hadn’t liked Ted McGuin, hadn’t liked it that Ted was younger, less educated, part of a different world; he’d been downright insulting about it, in fact. He’d acted like my father, with his disapproval and dire warnings.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hadn’t spoken to Sandy since I’d returned to San Francisco. I’d called him. I’d left messages. But he hadn’t phoned back. Until now, my reaction had been, well then, the hell with you.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s Laura.” This was the first time I’d called his work number. I guess I’d known I could reach him there.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tried to put the resentment away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sandy, God damn it. Say something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A slow exhalation. “Howdy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Still coming on like a laid-back cowboy, a just-folks Gary Cooper.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You knew I was back.” I left you enough messages.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yuh. Office down in SoMa, I hear.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Only a little south of Market.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Least you’re back in business. I was glad to learn.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then why didn’t you return my calls, you sanctimonious, paternalistic son of a bitch? “That’s why I’m calling. I’d like to hire you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Go on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“There’s a guru here in town—I don’t even have his full name yet. His followers call him Brother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A brief silence. “I know about him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“How?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Previous investigation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He couldn’t tell me about the investigation, but maybe he could tell me what he’d learned about Brother. That would save my client money; keep my fee low and make me look good.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I have a client who’s involved with him. I need background on him. Unless you have a conflict.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Depends who your client is. What the problem is.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Her name is Margaret Lenin. She did some kind of sex-therapy sessions with him. She let him videotape them. Now the tapes are available in at least one video rental place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Smooth move. She suing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“She doesn’t know what she wants to do. I haven’t seen the release she signed, and I don’t know what his plans are in terms of distribution of the videos.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Well.” I could hear him breathe into the mouthpiece. “I don’t see a conflict on my end. I don’t know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I waited awhile, and then I said, “I’m not with McGuin, but I don’t think that should matter. I think you were out of line.” I waited a little longer. “I think you were a real shithead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That your idea of an olive branch?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You could have returned my calls.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You could have come home with me and taken care of business instead of scratching your itch.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hung up. Conservative ex-cop, disapproving bastard, treating me like a kid. Worse, like his ex-wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When the phone rang a minute later, I knew it was him. I waited for one of the secretaries across the hall to put the call through.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“All right,” he said, a little extra Louisiana in his voice. “You want me, you got me.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5446b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceValue-4.vue
// module id = 78
// module chunks = 0